// extracted by mini-css-extract-plugin
module.exports = {"root":"AmaListItem_root__uOOMR","amaVideo":"AmaListItem_amaVideo__XIWld","storeType":"AmaListItem_storeType__dZq2m","infoWrapper":"AmaListItem_infoWrapper__6vT4N"};